/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferNote
 */
export interface OfferNote {
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    offerId: string;
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    authorEmail: string;
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof OfferNote
     */
    lastName: string;
    /**
     * 
     * @type {Date}
     * @memberof OfferNote
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OfferNote
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the OfferNote interface.
 */
export function instanceOfOfferNote(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "offerId" in value;
    isInstance = isInstance && "authorEmail" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function OfferNoteFromJSON(json: any): OfferNote {
    return OfferNoteFromJSONTyped(json, false);
}

export function OfferNoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferNote {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'offerId': json['offer_id'],
        'authorEmail': json['author_email'],
        'message': json['message'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function OfferNoteToJSON(value?: OfferNote | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'offer_id': value.offerId,
        'author_email': value.authorEmail,
        'message': value.message,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

